<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <div>
          <!--You can specify transitions on initial render. The `card-hidden` class will be present initially and then it will be removed-->
          <fade-render-transition>
            <card>
              <div slot="header">
                <h3 class="card-title text-center">Login</h3>
              </div>
              <div>
                <fg-input
                  label="Usuário"
                  placeholder="Digite o usuário"
                  type="email"
                  @keyup.enter.native="login"
                  v-model="model.username"
                ></fg-input>
                <fg-input
                  label="Senha"
                  type="password"
                  placeholder="Digite a senha"
                  @keyup.enter.native="login"
                  v-model="model.password"
                ></fg-input>
                <p class="text-danger" v-if="error">Falha na autenticação.</p>
              </div>
              <div class="text-center">
                <button class="btn btn-fill btn-info btn-round btn-wd" @click="login">Login</button>
                <br>
                <div class="forgot">
                  <router-link to="/recovery" class="card-category">Esqueci a Senha</router-link>
                </div>
              </div>
            </card>
          </fade-render-transition>
        </div>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import {
  Checkbox as LCheckbox,
  FadeRenderTransition
} from "src/components/index";

import AuthLayout from "./AuthLayout.vue";

export default {
  components: {
    LCheckbox,
    FadeRenderTransition,
    AuthLayout
  },
  created() {
    if (this.$store.state.auth.authenticated) {
      this.$router.replace({ name: "Geral" });
    }
  },
  data() {
    return {
      model: {
        username: "",
        password: ""
      },
      error: false
    };
  },
  methods: {
    login() {
      const { username, password } = this.model;
      if (username !== "" && password !== "") {
        this.$store
          .dispatch("auth/login", { username, password })
          .then(data => {
            this.$router.replace({ name: "App" });
            this.notifySuccess();
          })
          .catch(err => {
            console.log(err);
            this.error = true;
            this.notifyError();
          });
      } else {
        console.log("A username and password must be present");
      }
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Autenticado!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifyError() {
      this.$notify({
        message: "Erro</br>Autenticação rejeitada!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    }
  },
  beforeDestroy() {
    this.closeMenu();
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
